<template>
  <v-dialog v-model="dialogModel">
    <v-card>
      <v-card-title>
        <h2>{{ $t('message.selectLocation') }}</h2>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout column wrap>
            <v-flex xs12>
              <l-map
                :center="center"
                :zoom="zoom"
                @click="getPosition"
                @update:bounds="boundsUpdated"
                @update:center="centerUpdated"
                @update:zoom="zoomUpdated"
                ref="lMapRef"
                style="height: 50vh; width: 100%"
              >
                <l-marker :lat-lng="marker"></l-marker>
                <l-tile-layer :url="url"></l-tile-layer>
              </l-map>
            </v-flex>
            <v-flex xs12>
              <v-layout justify-end row>
                <v-btn outline @click="onClose" color="error">{{ $t('message.close') }}</v-btn>
                <v-btn outline @click="onSave" color="primary">{{ $t('message.add') }}</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const initLat = 10.178865;
const initLng = -64.683859;

export default {
  name: "Map",
  props: {
    dialog: {
      require: false,
      default: false
    }
  },
  data() {
    return {
      zoom: 12,
      center: [initLat, initLng],
      bounds: null,
      url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
      marker: [initLat, initLng],
      dialogModel: this.dialog
    };
  },
  methods: {
    onClose() {
      this.$emit("update:dialog", false);
    },
    getPosition(position) {
      this.marker = [position.latlng.lat, position.latlng.lng];
    },
    onSave() {
      this.$emit("position", { lng: this.marker[1], lat: this.marker[0] });
      this.$emit("update:dialog", false);
    },
    setPosition(lat, lng) {
      this.center = [lat, lng];
      this.marker = [lat, lng];
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    callMapInvalidateSize() {
      setTimeout(() => {
        this.$refs.lMapRef.mapObject.invalidateSize();
      }, 100);
    }
  },
  watch: {
    dialog(value) {
      this.dialogModel = value;
    },
    dialogModel(value) {
      this.$emit("update:dialog", value);
    }
  }
};
</script>

<style scoped>
</style>

